/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const log = {
  /**
   *  AJAX-日志查询
   * @param info
   * @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  pageByFuzzy(info,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LOG_PAGE_BY_FUZZY,
      {
        beginDate: info.startDate,
        endDate: info.endDate,
        staffId: info.staffId,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default log;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-log.js